import { Badge } from '@mantine/core'
import type { EstadoGateway } from '@/api/whatsappGateways'

// Cores semânticas da DS §2.3: em curso é informativo (inovareTeal), nunca azul genérico.
const ROTULO: Record<EstadoGateway, { texto: string; cor: string }> = {
  provisionando: { texto: 'Subindo', cor: 'inovareTeal' },
  provisionado: { texto: 'Provisionado', cor: 'green' },
  atualizando: { texto: 'Atualizando', cor: 'inovareTeal' },
  falhou: { texto: 'Falhou', cor: 'red' },
  removendo: { texto: 'Removendo', cor: 'inovareTeal' },
  removido: { texto: 'Removido', cor: 'gray' },
}

// `_falhar` marca `falhou` também na remoção (spec 2026-10-15 §5.2): quem diz qual das
// duas é o kind do último job, que só o detalhe tem.
const FALHOU_EM: Record<string, string> = { deprovision: 'Falhou ao remover', update: 'Falhou ao atualizar' }

export function RotuloDeEstado({ status, kindDoUltimoJob }: { status: EstadoGateway; kindDoUltimoJob?: string }) {
  const r = ROTULO[status]
  const texto = status === 'falhou' && kindDoUltimoJob ? (FALHOU_EM[kindDoUltimoJob] ?? r.texto) : r.texto
  return <Badge color={r.cor} variant="light">{texto}</Badge>
}
